import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import RichText from '../../Prismic/RichText';
import { replaceTextWithValues } from 'src/common/utils/text-replace';
import './OrderInformation.scss';

const OrderInformation = ({ label, number, isCancelled, characters }) => (
  <div className={cx('order-information', {
    'order-information--cancelled': isCancelled
  })}>
    <RichText
      fields={[{
        type: 'paragraph',
        text: replaceTextWithValues(label, {
          order_number: `#${number}`,
          characters,
        })
      }]}
    />
  </div>
);

OrderInformation.propTypes = {
  label: PropTypes.string.isRequired,
  number: PropTypes.string.isRequired,
  characters: PropTypes.string.isRequired,
  isCancelled: PropTypes.bool.isRequired,
};

export default OrderInformation;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Order/OrderInformation/OrderInformation.js